import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const SFservice = () => {
  return (
    <div className="sf-services">
      <h3>Our SEO Services in Noida</h3>
      <p className="sf-description">
        As a leading <b>SEO Company in Noida</b> , we offer a wide range of SEO
        services to help your business grow online.
      </p>

      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>On-Page SEO</h3>
          <p>
            On-page search engine optimization optimizes website content
            material, headings, meta tags, and structure. Our SEO Company in
            Noida improves rankings and consumer enjoy via proper key-word
            placement and exceptional optimized content.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Off-Page SEO</h3>
          <p>
            Off-page search engine optimization makes a speciality of
            constructing authority thru back links, social signals, and logo
            mentions. Our SEO Agency in Noida helps boom area authority and
            improve search engine scores successfully.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Technical SEO</h3>
          <p>
            Technical SEO improves website overall performance, pace, cellular
            usability, and indexing. Our SEO Company in Noida fixes crawl
            errors, enhances site shape, and guarantees serps can easily get
            entry to your internet site.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>Local SEO</h3>
          <p>
            Local SEO helps groups rank for location-based totally searches like
            offerings in Noida. Our SEO Agency in Noida optimizes Google
            Business Profile, nearby listings, and maps visibility for better
            reach.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>E-commerce SEO</h3>
          <p>
            E-commerce SEO optimizes product pages, classes, and key phrases to
            growth income. Our search engine marketing Company in Noida improves
            visibility, visitors, and conversions for online shops with
            effective search engine optimization techniques.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Mobile SEO Service</h3>
          <p>
            Mobile SEO guarantees your internet site is responsive, speedy, and
            user-pleasant on cellular gadgets. Our search engine optimization
            Agency in Noida enhances cell revel in to improve rankings and
            engagement across all gadgets.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Keyword Research</h3>
          <p>
            We identify high-performing keywords through research and competitor
            analysis to target the right audience, improve rankings, and drive
            qualified organic traffic.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3>Analytics & Reporting</h3>
          <p>
            We track website performance, analyze traffic and user behavior, and
            provide detailed reports to measure results, improve strategy, and
            maximize ROI.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>SEO Audit</h3>
          <p>
            We analyze your website to identify SEO issues, technical errors,
            and optimization gaps, providing actionable insights to improve
            rankings, performance, and visibility.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SFservice;
